import cx from "classnames"
import * as styles from "./styles.module.scss"
import Button from "../Button"
import GetStartedButton from "./GetStartedButton"
import NavbarCommon from "../NavbarCommon"
import React, { useContext } from "react"
import { NavContext } from "../Document"
import { useInView } from "react-intersection-observer"

export interface NavbarProps {
  getStartedLink?: string
  hideBackground?: boolean
  hideHamburger?: boolean
  hideLinks?: boolean
  hideSignIn?: boolean
  getStartedType?: GetStartedType
  isFlow?: boolean
  logoLink?: string
  logomark?: boolean
  startTransparent?: boolean
  startWhite?: boolean
  white?: boolean
}

const Navbar: React.FC<NavbarProps> = ({
  getStartedLink,
  hideHamburger,
  hideLinks,
  hideSignIn,
  isFlow,
  logoLink,
  logomark,
  getStartedType,
  startTransparent,
  startWhite,
  white,
}) => {
  const { isNavOpen } = useContext(NavContext)

  const [scrollRef, navRefInView] = useInView({ threshold: 0 })
  const [heroScrollRef, heroRefInView] = useInView({ threshold: 0 })

  return (
    <>
      <div className={styles.scrollRef} ref={scrollRef} />
      <div className={styles.heroScrollRef} ref={heroScrollRef} />
      <nav
        className={cx({
          [styles.navbar]: true,
          [styles.startWhite]: startWhite,
          [styles.white]: white,
          [styles.isScrolled]: !navRefInView,
          [styles.startTransparent]: startTransparent,
        })}
        id="navbar"
      >
        <div
          className={cx({
            [styles.background]: true,
            [styles.isNavOpen]: isNavOpen,
            // [styles.isHidden]: !isNavOpen,
          })}
        >
          <div className={styles.padding}>
            <NavbarCommon
              hideHamburger={Boolean(hideHamburger)}
              hideLinks={Boolean(hideLinks)}
              isFlow={Boolean(isFlow)}
              logoLink={logoLink}
              logomark={Boolean(logomark)}
              isScrolled={!navRefInView}
            />
            <div className={styles.buttons}>
              <ul className={styles.buttonsList}>
                {getStartedType && (
                  <li
                    className={cx({
                      [styles.buttonWrap]: true,
                    })}
                  >
                    <GetStartedButton
                      getStartedLink={getStartedLink}
                      getStartedType={getStartedType}
                      scrolled={!heroRefInView}
                    />
                  </li>
                )}
                {!hideSignIn && (
                  <>
                    <li
                      className={cx({
                        [styles.buttonWrap]: true,
                      })}
                    >
                      <div data-qa="sign-in-header">
                        <Button size="md" type="secondaryBorder">
                          Sign in
                        </Button>
                      </div>
                    </li>
                    {/* <li
                      className={cx({
                        [styles.buttonWrap]: true,
                      })}
                    >
                      <Link to="/sign-out">
                        <Button size="md" type="secondaryBorder">
                          Sign out
                        </Button>
                      </Link>
                    </li>
                    <li
                      className={cx({
                        [styles.buttonWrap]: true,
                      })}
                    >
                      <Link to="/sign-out">
                        <Button size="md" type="secondaryBorder">
                          Sign out
                        </Button>
                      </Link>
                    </li>
                    <li
                      className={cx({
                        [styles.buttonWrap]: true,
                      })}
                    >
                      <Link to="/loan-files">
                        <Button size="md" type="secondaryBorder">
                          Loans
                        </Button>
                      </Link>
                    </li>
                    <li
                      className={cx({
                        [styles.buttonWrap]: true,
                      })}
                    >
                      <Link to="/sign-in">
                        <Button size="md" type="secondaryBorder">
                          Your loan
                        </Button>
                      </Link>
                    </li> */}
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}

export default Navbar
